/**
 * created by li si yi
 * 资源下载记录
 */
import React, {Component} from 'react';
import {Input, Button, DatePicker, Pagination, Select} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import BaseComponent from "../../../../../base/BaseComponent";
import BaseTable from "../../../../components/baseTable/BaseTable";
import {unitConvert} from "../../../../../utils"

const {RangePicker} = DatePicker;
const {Search} = Input;
const {Option} = Select;

export default class ResourceDownloadRecord extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    title: '名称',
                    dataIndex: 'fileName',
                    ellipsis: true,
                    key: 'fileName',
                    render: (text, record) => {
                        return (
                            <div>
                                {
                                    record.fileIcon ? <img src={record.fileIcon} style={{
                                            width: 25,
                                            height: 20,
                                            objectFit: 'cover',
                                            marginRight: '10px'
                                        }}/> :
                                        <div style={{width: 25, height: 20, marginRight: '10px'}}/>
                                }
                                {text}
                            </div>
                        )
                    }
                },
                {
                    title: '下载时间',
                    dataIndex: 'downLoadTime',
                    ellipsis: true,
                    width: '200px',
                    key: 'downLoadTime',
                    render: (text) => {
                        return (
                            <span>
                                {text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}
                            </span>
                        )
                    }
                },
                {
                    title: '大小',
                    dataIndex: 'size',
                    ellipsis: true,
                    width: '200px',
                    key: 'size',
                    render: (text) => {
                        return (
                            <span>{text ? unitConvert(text) : ""}</span>
                        )
                    }
                },
                {
                    title: '操作者',
                    dataIndex: 'downLoadName',
                    ellipsis: true,
                    key: 'downLoadName',
                    width: '200px',
                    render: (text) => {
                        return (
                            <span>{text ? text : ''}</span>
                        )
                    }
                },
            ],
            params: {
                page: 1,   //页数
                size: 10,  //每页数量
                queryStr: "",  //模糊查询
                startTime: "",   //开始时间
                endTime: "",  //结束时间
                resourceType: "5",// 类型
            },
            dataSource: [],//列表数据
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDataSource();
    }

    render() {
        return (
            <div style={{margin: "15px"}}>
                <div style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    maxHeight: 'calc(100vh - 100px)',
                    borderRadius: '5px',
                    // overflow: 'hidden',
                }}>
                    <div style={{padding: '24px 32px'}}>
                        {this.renderHeader()}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        )
    }

    // 头部
    renderHeader() {
        const publicStyle = {marginRight: 20};
        return (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{display: 'flex'}}>
                    <div style={publicStyle}>
                        <Search
                            placeholder="请输入资源名称"
                            value={this.state.params.queryStr}
                            onChange={(e) => {
                                this.state.params.queryStr = e.target.value;
                                this.setState({})
                            }}
                            onSearch={value => this.messageOnSearch(value)}
                            style={{width: 200}}
                        />
                    </div>
                    <div style={publicStyle}>
                        <Select value={this.state.params.resourceType} style={{width: 200}}
                                onChange={(val) => this.handleChangeType(val)}>
                            <Option value={'5'}>全部类型</Option>
                            <Option value={'1'}>图片</Option>
                            <Option value={'2'}>视频</Option>
                            <Option value={'3'}>音频</Option>
                            <Option value={'4'}>其他</Option>
                        </Select>
                    </div>
                    <div style={publicStyle}>
                        <RangePicker value={[this.state.params.startTime, this.state.params.endTime]}
                                     onChange={this.rangePickerOnChange} style={{width: 240, height: 30}}/>
                    </div>
                    <Button style={publicStyle} type="primary" onClick={() => this.revert()}>重置</Button>
                </div>
            </div>
        )
    }

    //类型
    handleChangeType = (val) => {
        let {params} = this.state;
        params.page = 1;
        params.resourceType = val;
        this.setState({});
        this.getDataSource();
    };
    // 日期改变
    rangePickerOnChange = (data, dateString) => {
        let startTime = data && data[0] ? data[0].startOf('day') : null;
        let endTime = data && data[1] ? data[1].endOf('day') : null;
        this.state.params.startTime = startTime;
        this.state.params.endTime = endTime;
        this.setState({});
        this.getDataSource();
    };

    //内容
    renderContent() {
        console.log("this.state.dataSource：  ", this.state.dataSource);
        return (
            <div className={"nullStyle"}>
                <div style={{maxHeight: 'calc(100vh - 261px )', padding: '0px 32px'}}>
                    <Scrollbars autoHeight autoHeightMax={"calc(100vh - 261px )"}>
                        <BaseTable
                            rowKey="id"
                            dataSource={this.state.dataSource}
                            columns={this.state.columns}
                            pagination={false}
                            locale={{emptyText: '暂无数据'}}
                        />
                    </Scrollbars>
                    <style>{`
                    .nullStyle .ant-table-placeholder{
                       display:flex;
                       justify-content: center;
                       align-items: center;
                    //    height:500px;
                       border-bottom:none;
                    }
                `}</style>
                </div>
                {this.renderFooter()}
            </div>
        )
    }

    // 分页
    renderFooter = () => {
        let {params, total} = this.state;
        // 获取当前tab参数
        let {page, size} = params;
        return (
            <div className={'pagination'} >
                <div style={{padding: "0 10px 0"}}>共{total}条数据</div>
                <Pagination
                    showSizeChanger
                    current={page}
                    pageSize={size}
                    total={total}
                    showQuickJumper={true}
                    onChange={(page, pageSize) => this.pageChange(page, pageSize)}
                    onShowSizeChange={(page, pageSize) => this.pageChange(page, pageSize)}
                />
            </div>
        )
    };

    //获取列表数据
    getDataSource = () => {
        let {params} = this.state;
        let body = JSON.parse(JSON.stringify(params));
        if (body.startTime && body.endTime) {
            body.startTime = moment(body.startTime).format('YYYY-MM-DD');
            body.endTime = moment(body.endTime).format('YYYY-MM-DD');
        }
        this.request({
            url: '/cm-sites-storage-management/zykStatistics/DownloadRecords',
            method: 'get',
            body: body,
            callBack: (res) => {
                console.log("============", res);
                let dataSource = [];
                let total = 0;
                if (res) {
                    dataSource = res.data;
                    total = res.count;
                }
                this.setState({dataSource, total})
            }
        })
    };

    //分页
    pageChange(page, pageSize) {
        let {params} = this.state;
        params.page = page;
        params.size = pageSize;
        this.getDataSource();
    }

    //作者名称搜索
    messageOnSearch(value) {
        // console.log(value);
        let {params} = this.state;
        params.queryStr = value;
        params.page = 1;
        this.getDataSource();
    }

    //重置按钮
    revert() {
        this.state.params = {
            page: 1,
            size: 10,
            queryStr: "",
            startTime: "",
            endTime: "",
            resourceType: "5",
        };
        this.setState({});
        this.getDataSource()
    }
}